"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UndrawWallPost = exports.UndrawWallet = exports.UndrawVisualData = exports.UndrawUpVote = exports.UndrawUploadImages = exports.UndrawUnderConstruction = exports.UndrawTransferMoney = exports.UndrawSometingWrong = exports.UndrawSnapTheMoment = exports.UndrawSettings = exports.UndrawServerDown = exports.UndrawSecurity = exports.UndrawSecureLogin = exports.UndrawSafe = exports.UndrawRightPlaces = exports.UndrawRightDirection = exports.UndrawQuietTown = exports.UndrawQaEngeneers = exports.UndrawProfileData = exports.UndrawPersonalFile = exports.UndrawPayOnline = exports.UndrawPageNotFound = exports.UndrawOrderConfirmed = exports.UndrawMyApp = exports.UndrawMobileSuccess = exports.UndrawMobilePhotos = exports.UndrawMessageSend = exports.UndrawIntenseFeeling = exports.UndrawHouses3 = exports.UndrawForSale = exports.UndrawFileSearch = exports.UndrawDocuments = exports.UndrawData = exports.UndrawContractConfirmed = exports.UndrawConfirmation = exports.UndrawChoosingHouse = exports.UndrawCandidate = exports.UndrawBuyHouse = exports.UndrawBugFixing = exports.UndrawBirthdayCake = exports.UndrawBestPlace = exports.UndrawAuthentication = exports.UndrawAddTasks = exports.UndrawAccount = exports.UndrawAccessDenied = exports.UndrawAcceptTerms = void 0;
var UndrawAcceptTerms_1 = __importDefault(require("./UndrawAcceptTerms"));
var UndrawAccessDenied_1 = __importDefault(require("./UndrawAccessDenied"));
var UndrawAccount_1 = __importDefault(require("./UndrawAccount"));
var UndrawAddTasks_1 = __importDefault(require("./UndrawAddTasks"));
var UndrawAuthentication_1 = __importDefault(require("./UndrawAuthentication"));
var UndrawBestPlace_1 = __importDefault(require("./UndrawBestPlace"));
var UndrawBirthdayCake_1 = __importDefault(require("./UndrawBirthdayCake"));
var UndrawBugFixing_1 = __importDefault(require("./UndrawBugFixing"));
var UndrawBuyHouse_1 = __importDefault(require("./UndrawBuyHouse"));
var UndrawCandidate_1 = __importDefault(require("./UndrawCandidate"));
var UndrawChoosingHouse_1 = __importDefault(require("./UndrawChoosingHouse"));
var UndrawConfirmation_1 = __importDefault(require("./UndrawConfirmation"));
var UndrawContractConfirmed_1 = __importDefault(require("./UndrawContractConfirmed"));
var UndrawData_1 = __importDefault(require("./UndrawData"));
var UndrawDocuments_1 = __importDefault(require("./UndrawDocuments"));
var UndrawFileSearch_1 = __importDefault(require("./UndrawFileSearch"));
var UndrawForSale_1 = __importDefault(require("./UndrawForSale"));
var UndrawHouses3_1 = __importDefault(require("./UndrawHouses3"));
var UndrawIntenseFeeling_1 = __importDefault(require("./UndrawIntenseFeeling"));
var UndrawMessageSend_1 = __importDefault(require("./UndrawMessageSend"));
var UndrawMobilePhotos_1 = __importDefault(require("./UndrawMobilePhotos"));
var UndrawMobileSuccess_1 = __importDefault(require("./UndrawMobileSuccess"));
var UndrawMyApp_1 = __importDefault(require("./UndrawMyApp"));
var UndrawOrderConfirmed_1 = __importDefault(require("./UndrawOrderConfirmed"));
var UndrawPageNotFound_1 = __importDefault(require("./UndrawPageNotFound"));
var UndrawPayOnline_1 = __importDefault(require("./UndrawPayOnline"));
var UndrawPersonalFile_1 = __importDefault(require("./UndrawPersonalFile"));
var UndrawProfileData_1 = __importDefault(require("./UndrawProfileData"));
var UndrawQaEngeneers_1 = __importDefault(require("./UndrawQaEngeneers"));
var UndrawQuietTown_1 = __importDefault(require("./UndrawQuietTown"));
var UndrawRightDirection_1 = __importDefault(require("./UndrawRightDirection"));
var UndrawRightPlaces_1 = __importDefault(require("./UndrawRightPlaces"));
var UndrawSafe_1 = __importDefault(require("./UndrawSafe"));
var UndrawSecureLogin_1 = __importDefault(require("./UndrawSecureLogin"));
var UndrawSecurity_1 = __importDefault(require("./UndrawSecurity"));
var UndrawServerDown_1 = __importDefault(require("./UndrawServerDown"));
var UndrawSettings_1 = __importDefault(require("./UndrawSettings"));
var UndrawSnapTheMoment_1 = __importDefault(require("./UndrawSnapTheMoment"));
var UndrawSometingWrong_1 = __importDefault(require("./UndrawSometingWrong"));
var UndrawTransferMoney_1 = __importDefault(require("./UndrawTransferMoney"));
var UndrawUnderConstruction_1 = __importDefault(require("./UndrawUnderConstruction"));
var UndrawUploadImages_1 = __importDefault(require("./UndrawUploadImages"));
var UndrawUpVote_1 = __importDefault(require("./UndrawUpVote"));
var UndrawVisualData_1 = __importDefault(require("./UndrawVisualData"));
var UndrawWallet_1 = __importDefault(require("./UndrawWallet"));
var UndrawWallPost_1 = __importDefault(require("./UndrawWallPost"));
var UndrawAcceptTerms_2 = require("./UndrawAcceptTerms");
Object.defineProperty(exports, "UndrawAcceptTerms", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawAcceptTerms_2).default;
  }
});
var UndrawAccessDenied_2 = require("./UndrawAccessDenied");
Object.defineProperty(exports, "UndrawAccessDenied", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawAccessDenied_2).default;
  }
});
var UndrawAccount_2 = require("./UndrawAccount");
Object.defineProperty(exports, "UndrawAccount", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawAccount_2).default;
  }
});
var UndrawAddTasks_2 = require("./UndrawAddTasks");
Object.defineProperty(exports, "UndrawAddTasks", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawAddTasks_2).default;
  }
});
var UndrawAuthentication_2 = require("./UndrawAuthentication");
Object.defineProperty(exports, "UndrawAuthentication", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawAuthentication_2).default;
  }
});
var UndrawBestPlace_2 = require("./UndrawBestPlace");
Object.defineProperty(exports, "UndrawBestPlace", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawBestPlace_2).default;
  }
});
var UndrawBirthdayCake_2 = require("./UndrawBirthdayCake");
Object.defineProperty(exports, "UndrawBirthdayCake", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawBirthdayCake_2).default;
  }
});
var UndrawBugFixing_2 = require("./UndrawBugFixing");
Object.defineProperty(exports, "UndrawBugFixing", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawBugFixing_2).default;
  }
});
var UndrawBuyHouse_2 = require("./UndrawBuyHouse");
Object.defineProperty(exports, "UndrawBuyHouse", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawBuyHouse_2).default;
  }
});
var UndrawCandidate_2 = require("./UndrawCandidate");
Object.defineProperty(exports, "UndrawCandidate", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawCandidate_2).default;
  }
});
var UndrawChoosingHouse_2 = require("./UndrawChoosingHouse");
Object.defineProperty(exports, "UndrawChoosingHouse", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawChoosingHouse_2).default;
  }
});
var UndrawConfirmation_2 = require("./UndrawConfirmation");
Object.defineProperty(exports, "UndrawConfirmation", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawConfirmation_2).default;
  }
});
var UndrawContractConfirmed_2 = require("./UndrawContractConfirmed");
Object.defineProperty(exports, "UndrawContractConfirmed", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawContractConfirmed_2).default;
  }
});
var UndrawData_2 = require("./UndrawData");
Object.defineProperty(exports, "UndrawData", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawData_2).default;
  }
});
var UndrawDocuments_2 = require("./UndrawDocuments");
Object.defineProperty(exports, "UndrawDocuments", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawDocuments_2).default;
  }
});
var UndrawFileSearch_2 = require("./UndrawFileSearch");
Object.defineProperty(exports, "UndrawFileSearch", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawFileSearch_2).default;
  }
});
var UndrawForSale_2 = require("./UndrawForSale");
Object.defineProperty(exports, "UndrawForSale", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawForSale_2).default;
  }
});
var UndrawHouses3_2 = require("./UndrawHouses3");
Object.defineProperty(exports, "UndrawHouses3", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawHouses3_2).default;
  }
});
var UndrawIntenseFeeling_2 = require("./UndrawIntenseFeeling");
Object.defineProperty(exports, "UndrawIntenseFeeling", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawIntenseFeeling_2).default;
  }
});
var UndrawMessageSend_2 = require("./UndrawMessageSend");
Object.defineProperty(exports, "UndrawMessageSend", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawMessageSend_2).default;
  }
});
var UndrawMobilePhotos_2 = require("./UndrawMobilePhotos");
Object.defineProperty(exports, "UndrawMobilePhotos", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawMobilePhotos_2).default;
  }
});
var UndrawMobileSuccess_2 = require("./UndrawMobileSuccess");
Object.defineProperty(exports, "UndrawMobileSuccess", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawMobileSuccess_2).default;
  }
});
var UndrawMyApp_2 = require("./UndrawMyApp");
Object.defineProperty(exports, "UndrawMyApp", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawMyApp_2).default;
  }
});
var UndrawOrderConfirmed_2 = require("./UndrawOrderConfirmed");
Object.defineProperty(exports, "UndrawOrderConfirmed", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawOrderConfirmed_2).default;
  }
});
var UndrawPageNotFound_2 = require("./UndrawPageNotFound");
Object.defineProperty(exports, "UndrawPageNotFound", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawPageNotFound_2).default;
  }
});
var UndrawPayOnline_2 = require("./UndrawPayOnline");
Object.defineProperty(exports, "UndrawPayOnline", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawPayOnline_2).default;
  }
});
var UndrawPersonalFile_2 = require("./UndrawPersonalFile");
Object.defineProperty(exports, "UndrawPersonalFile", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawPersonalFile_2).default;
  }
});
var UndrawProfileData_2 = require("./UndrawProfileData");
Object.defineProperty(exports, "UndrawProfileData", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawProfileData_2).default;
  }
});
var UndrawQaEngeneers_2 = require("./UndrawQaEngeneers");
Object.defineProperty(exports, "UndrawQaEngeneers", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawQaEngeneers_2).default;
  }
});
var UndrawQuietTown_2 = require("./UndrawQuietTown");
Object.defineProperty(exports, "UndrawQuietTown", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawQuietTown_2).default;
  }
});
var UndrawRightDirection_2 = require("./UndrawRightDirection");
Object.defineProperty(exports, "UndrawRightDirection", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawRightDirection_2).default;
  }
});
var UndrawRightPlaces_2 = require("./UndrawRightPlaces");
Object.defineProperty(exports, "UndrawRightPlaces", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawRightPlaces_2).default;
  }
});
var UndrawSafe_2 = require("./UndrawSafe");
Object.defineProperty(exports, "UndrawSafe", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawSafe_2).default;
  }
});
var UndrawSecureLogin_2 = require("./UndrawSecureLogin");
Object.defineProperty(exports, "UndrawSecureLogin", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawSecureLogin_2).default;
  }
});
var UndrawSecurity_2 = require("./UndrawSecurity");
Object.defineProperty(exports, "UndrawSecurity", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawSecurity_2).default;
  }
});
var UndrawServerDown_2 = require("./UndrawServerDown");
Object.defineProperty(exports, "UndrawServerDown", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawServerDown_2).default;
  }
});
var UndrawSettings_2 = require("./UndrawSettings");
Object.defineProperty(exports, "UndrawSettings", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawSettings_2).default;
  }
});
var UndrawSnapTheMoment_2 = require("./UndrawSnapTheMoment");
Object.defineProperty(exports, "UndrawSnapTheMoment", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawSnapTheMoment_2).default;
  }
});
var UndrawSometingWrong_2 = require("./UndrawSometingWrong");
Object.defineProperty(exports, "UndrawSometingWrong", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawSometingWrong_2).default;
  }
});
var UndrawTransferMoney_2 = require("./UndrawTransferMoney");
Object.defineProperty(exports, "UndrawTransferMoney", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawTransferMoney_2).default;
  }
});
var UndrawUnderConstruction_2 = require("./UndrawUnderConstruction");
Object.defineProperty(exports, "UndrawUnderConstruction", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawUnderConstruction_2).default;
  }
});
var UndrawUploadImages_2 = require("./UndrawUploadImages");
Object.defineProperty(exports, "UndrawUploadImages", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawUploadImages_2).default;
  }
});
var UndrawUpVote_2 = require("./UndrawUpVote");
Object.defineProperty(exports, "UndrawUpVote", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawUpVote_2).default;
  }
});
var UndrawVisualData_2 = require("./UndrawVisualData");
Object.defineProperty(exports, "UndrawVisualData", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawVisualData_2).default;
  }
});
var UndrawWallet_2 = require("./UndrawWallet");
Object.defineProperty(exports, "UndrawWallet", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawWallet_2).default;
  }
});
var UndrawWallPost_2 = require("./UndrawWallPost");
Object.defineProperty(exports, "UndrawWallPost", {
  enumerable: true,
  get: function () {
    return __importDefault(UndrawWallPost_2).default;
  }
});
exports.default = {
  'acceptTerms': UndrawAcceptTerms_1.default,
  'accessDenied': UndrawAccessDenied_1.default,
  'account': UndrawAccount_1.default,
  'addTasks': UndrawAddTasks_1.default,
  'authentication': UndrawAuthentication_1.default,
  'bestPlace': UndrawBestPlace_1.default,
  'birthdayCake': UndrawBirthdayCake_1.default,
  'bugFixing': UndrawBugFixing_1.default,
  'buyHouse': UndrawBuyHouse_1.default,
  'candidate': UndrawCandidate_1.default,
  'choosingHouse': UndrawChoosingHouse_1.default,
  'confirmation': UndrawConfirmation_1.default,
  'contractConfirmed': UndrawContractConfirmed_1.default,
  'data': UndrawData_1.default,
  'documents': UndrawDocuments_1.default,
  'fileSearch': UndrawFileSearch_1.default,
  'forSale': UndrawForSale_1.default,
  'houses3': UndrawHouses3_1.default,
  'intenseFeeling': UndrawIntenseFeeling_1.default,
  'messageSend': UndrawMessageSend_1.default,
  'mobilePhotos': UndrawMobilePhotos_1.default,
  'mobileSuccess': UndrawMobileSuccess_1.default,
  'myApp': UndrawMyApp_1.default,
  'orderConfirmed': UndrawOrderConfirmed_1.default,
  'pageNotFound': UndrawPageNotFound_1.default,
  'payOnline': UndrawPayOnline_1.default,
  'personalFile': UndrawPersonalFile_1.default,
  'profileData': UndrawProfileData_1.default,
  'qaEngeneers': UndrawQaEngeneers_1.default,
  'quietTown': UndrawQuietTown_1.default,
  'rightDirection': UndrawRightDirection_1.default,
  'rightPlaces': UndrawRightPlaces_1.default,
  'safe': UndrawSafe_1.default,
  'secureLogin': UndrawSecureLogin_1.default,
  'security': UndrawSecurity_1.default,
  'serverDown': UndrawServerDown_1.default,
  'settings': UndrawSettings_1.default,
  'snapTheMoment': UndrawSnapTheMoment_1.default,
  'sometingWrong': UndrawSometingWrong_1.default,
  'transferMoney': UndrawTransferMoney_1.default,
  'underConstruction': UndrawUnderConstruction_1.default,
  'uploadImages': UndrawUploadImages_1.default,
  'upVote': UndrawUpVote_1.default,
  'visualData': UndrawVisualData_1.default,
  'wallet': UndrawWallet_1.default,
  'wallPost': UndrawWallPost_1.default
};